<template>
  <div class="p-6 bg-white rounded-xl shadow-md">
    <h3 class="text-xl font-bold text-purple-600 inline-block transition-all duration-500">
      <span
          class="bg-clip-text text-transparent bg-gradient-to-r from-purple-500 via-pink-500 to-blue-500 hover:animate-pulse">
         سفارش های ارسال شده
      </span>
      <span
          class="mr-4 bg-clip-text text-transparent bg-gradient-to-r from-purple-900 via-pink-900 to-blue-900 hover:animate-pulse">
            {{ order_total }}
            <span class="text-[8px] text-gray-500">سفارش</span>
      </span>

    </h3>

    <div class="mt-2 flex flex-col md:flex-row md:items-center justify-between mb-4 gap-4">
      <div class="flex flex-wrap gap-2">
        <input v-model="filters.id" @input="fetchOrders" type="number"
               placeholder="شماره سفارش"
               class="px-3 py-2 bg-gray-100 text-sm rounded-lg border w-40 text-right">
        <input v-model="filters.search" @input="fetchOrders" type="text"
               placeholder="جستجو"
               class="px-3 py-2 bg-gray-100 text-sm rounded-lg border w-30 text-right">
        <select v-model="filters.quick_date_filter" @change="applyQuickDateFilter"
                class="px-3 py-2 bg-gray-100 text-sm rounded-lg border text-right">
          <option value="">فیلتر تاریخ</option>
          <option v-for="(label, key) in quickDateLAbles" :key="key" :value="key">{{ label }}</option>
        </select>

        <date placeholder="از تاریخ" v-model="filters.date_from" @input="fetchOrders"></date>
        <date placeholder="تا تاریخ" v-model="filters.date_to" @input="fetchOrders"></date>
      </div>
      <div class="left-2">
        <button @click="printOrders"
                class="bg-purple-500 hover:bg-purple-700 text-white px-3 py-2 rounded-lg transition-all duration-300 ease-in-out transform hover:hover:scale-105 hover:bg-gradient-to-r hover:from-purple-500 hover:via-pink-500 hover:to-blue-500 hover:shadow-md hover:animate-pulse">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
          </svg>
        </button>
      </div>
    </div>
    <div
        class="flex items-center justify-between w-full bg-white border border-gray-100 rounded-lg px-4 py-2 mb-4 shadow-sm"
    >
      <svg class="w-10 h-10 transform group-hover:scale-105 transition" viewBox="0 0 36 36">
        <path
            class="text-gray-200"
            stroke="currentColor"
            stroke-width="4"
            fill="none"
            d="M18 2.0845
                 a 15.9155 15.9155 0 0 1 0 31.831
                 a 15.9155 15.9155 0 0 1 0 -31.831"
        />
        <path
            class="text-green-500"
            stroke="currentColor"
            stroke-width="4"
            fill="none"
            stroke-dasharray="70, 100"
            d="M18 2.0845
                 a 15.9155 15.9155 0 0 1 0 31.831
                 a 15.9155 15.9155 0 0 1 0 -31.831"
        />
        <text x="50%" y="50%" text-anchor="middle" dy=".3em" class="text-sm fill-green-600 font-bold">🚚</text>
      </svg>

      <div class="mr-3 flex flex-col leading-tight">
        <span class="text-[11px] text-gray-400 font-medium">مبلغ کل</span>
        <span
            class="text-sm font-bold bg-gradient-to-r from-green-500 via-emerald-500 to-teal-500 bg-clip-text text-transparent"
        >
        سفارش‌های ارسال‌شده
      </span>
      </div>

      <div class="text-sm font-extrabold text-green-600 tracking-tight tabular-nums">
        {{ total | toMoney }}
        تومان
      </div>
    </div>
    <div class="overflow-x-auto">
      <table class="min-w-full table-auto text-right border border-gray-200">
        <thead class="bg-gray-50 text-sm text-gray-700">
        <tr>
          <th class="text-center p-3 border text-[9px]">ردیف</th>
          <th class="text-center p-3 border text-[9px]">شماره سفارش</th>
          <th class="text-center p-3 border text-[9px]">تاریخ</th>
          <th class="text-center p-3 border text-[9px]">کد رهگیری اکسونی</th>
          <th class="text-center p-3 border text-[9px]">کد رهگیری پستی</th>
          <th class="text-center p-3 border text-[9px]">وضعیت</th>
          <th class="text-center p-3 border text-[9px]">تعداد اقلام</th>
          <th class="text-center p-3 border text-[9px]">مبلغ سفارش</th>
          <th class="text-center p-3 border text-[9px]">هزینه ارسال</th>
          <th class="text-center p-3 border text-[9px]">مبلغ کل</th>
          <th class="text-center p-3 border text-[9px]">مشتری</th>
          <th class="text-center p-3 border text-[9px]">مسئول بسته‌بندی</th>
          <th class="text-center p-3 border text-[9px]"></th>
        </tr>
        </thead>
        <tbody class="text-gray-600 text-sm">
        <tr v-for="order in orders" :key="order.id"
            class="cursor-pointer hover:bg-gray-50 transition"
            @click="$router.push(`/panel/adminOrderDetail/${order.id}`)">
          <td class="text-center p-2 border">{{ orders.indexOf(order) + 1 }}</td>
          <td class="text-center p-2 border">{{ order.id }}</td>
          <td class="text-center p-2 border text-[9px]">{{ formatDate(order.date_time) }}</td>
          <td class="text-center p-2 border text-[10px]">{{ order.exuni_tracking_code }}</td>
          <td class="text-center p-2 border text-[10px]">{{ order.post_tracking_code }}</td>
          <td class="text-center p-2 border">
            <span :class="statusClass(order.status)">
              {{ statusLabels[order.status] || order.status }}
            </span>
          </td>
          <td class="text-center p-2 border">{{ order.total_product_quantity | toMoney }}
            <span class="text-[8px] text-gray-500">عدد</span>
          </td>
          <td class="text-center p-2 border">{{ order.total_price | toMoney }}
            <span class="text-[8px] text-gray-500">تومان</span>
          </td>
          <td class="text-center p-2 border">{{ order.post_price | toMoney }}
            <span class="text-[8px] text-gray-500">تومان</span>
          </td>
          <td class="text-center p-2 border">{{ order.final_amount | toMoney }}
            <span class="text-[8px] text-gray-500">تومان</span>
          </td>
          <td class="text-center p-2 border">
            <span class="text-[12px]">{{order.customer.mobile_number}}</span>
            <span class="m-1 mr-1 text-[8px] text-gray-500">{{order.shipment_address.first_name}}</span>
            <span class="text-[8px] text-gray-500">{{order.shipment_address.last_name}}</span>
          </td>
          <td class="text-center p-2 border">
            <span class="text-[9px]">{{order.packager_name}}</span>
          </td>
          <td class="text-center p-2 border text-[10px]">
            <div class="relative flex items-center justify-center group">
              <template v-if="order.is_printed">
                <!-- Green printer with checkmark (RTL aligned) -->
                <span class="flex items-center text-green-500">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"/>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24"
             stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
        </svg>
      </span>
                <span
                    class="absolute z-10 hidden group-hover:block left-full top-1/2 transform -translate-y-1/2 mr-2 px-2 py-1 text-xs text-white bg-gray-800 rounded whitespace-nowrap">
        چاپ شده توسط {{ order.printed_user }}
      </span>
              </template>
              <template v-else>
                <!-- Red printer with clock (RTL aligned) -->
                <span class="flex items-center text-red-500">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"/>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24"
             stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
      </span>
                <span
                    class="absolute z-10 hidden group-hover:block left-full top-1/2 transform -translate-y-1/2 mr-2 px-2 py-1 text-xs text-white bg-gray-800 rounded whitespace-nowrap">
        هنوز چاپ نشده است
      </span>
              </template>
            </div>
          </td>
        </tr>

        <tr class="bg-gray-100 font-bold text-gray-800">
          <td class="text-center p-2 border">
            {{ orders.length }}
            <span class="text-[8px] text-gray-500">سفارش</span>
          </td>

          <td class="text-center p-2 border text-center" colspan="5">جمع کل</td>
          <td class="text-center p-2 border">
            {{ totals.total_product_quantity }}
            <span class="text-[8px] text-gray-500">عدد</span>
          </td>
          <td class="text-center p-2 border">
            {{ totals.total_price | toMoney }}
            <span class="text-[8px] text-gray-500">تومان</span>
          </td>
          <td class="text-center p-2 border">
            {{ totals.post_price | toMoney }}
            <span class="text-[8px] text-gray-500">تومان</span>
          </td>
          <td class="text-center p-2 border">
            {{ totals.total_discount | toMoney }}
            <span class="text-[8px] text-gray-500">تومان</span>
          </td>
          <td class="text-center p-2 border">
            {{ totals.final_amount | toMoney }}
            <span class="text-[8px] text-gray-500">تومان</span>
          </td>
          <td class="text-center p-2 border" colspan="3"></td>
        </tr>

        </tbody>
      </table>
      <div class="mt-6 flex justify-center items-center gap-2 flex-wrap text-sm">
        <button
            @click="changePage(pagination.current_page - 1)"
            :disabled="pagination.current_page === 1"
            class="px-3 py-1 rounded border bg-white text-gray-600 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          قبلی
        </button>

        <button
            v-for="page in totalPages"
            :key="page"
            @click="changePage(page)"
            :class="[
        'px-3 py-1 rounded border',
        page === pagination.current_page ? 'bg-purple-600 text-white' : 'bg-white text-gray-600 hover:bg-gray-100'
      ]"
        >
          {{ page }}
        </button>

        <button
            @click="changePage(pagination.current_page + 1)"
            :disabled="pagination.page_size > orders.length"
            class="px-3 py-1 rounded border bg-white text-gray-600 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          بعدی
        </button>
      </div>
    </div>

    <div class="p-6 bg-white rounded-xl shadow-md relative">
      <div v-if="isLoading" class="absolute inset-0 bg-white bg-opacity-70 flex items-center justify-center z-50 rounded-xl">
        <div class="text-center">
          <svg class="animate-spin h-12 w-12 text-purple-500 mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <p class="mt-2 text-purple-600">در حال بارگذاری...</p>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: 'ShippedOrdersList',
  data() {
    return {
      pagination: {
        current_page: 1,
        page_size: 100,
        total_items: 0
      },
      showNotification: false,
      total: 0,
      order_total: 0,
      notificationMessage: '',
      notificationType: 'success',
      showPopup: false,
      orders: [],
      selected: [],
      isLoading: false,
      selectAll: false,
      filters: {
        id: '',
        status: '',
        search: '',
        date_from: '',
        date_to: '',
        quick_date_filter: ''
      },
      statusLabels: {
        pe: "در انتظار پرداخت",
        pa: "جاری",
        pr: "درحال بسته بندی",
        pc: "بسته بندی شد",
        sh: "ارسال شده",
        de: "تحویل شده",
        ca: "لغو شده",
        re: "مرجوعی"
      },
      quickDateLAbles: {
        today: "امروز",
        yesterday: "دیروز",
        this_month: "این ماه",
      },
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.pagination.total_items / this.pagination.page_size);
    },
    filteredOrders() {

      return this.orders
    },
    totals() {
      return this.filteredOrders.reduce(
          (sum, order) => {
            sum.total_product_quantity += Number(order.total_product_quantity || 0);
            sum.total_price += Number(order.total_price || 0);
            sum.post_price += Number(order.post_price || 0);
            sum.total_discount += Number(order.total_discount || 0);
            sum.final_amount += Number(order.final_amount || 0);
            return sum;
          },
          {
            total_product_quantity: 0,
            total_price: 0,
            post_price: 0,
            total_discount: 0,
            final_amount: 0,
          }
      );
    }
  },
  methods: {
    changePage(page) {
      this.pagination.current_page = page;
      this.fetchOrders();
    },
    showNotificationMessage(message, type = 'success') {
      this.notificationMessage = message;
      this.notificationType = type;
      this.showNotification = true;
      setTimeout(() => {
        this.showNotification = false;
      }, 5000);
    },
    fetchOrders() {
      this.isLoading = true; // Show loading before request

      let offset = (this.pagination.current_page - 1) * this.pagination.page_size;
      let fetch_url = `shop/shopOrderList/all?status=sh&limit=${this.pagination.page_size}&offset=${offset}&`
      fetch_url += `status=sh&`
      if (this.filters.id){
        fetch_url += `id=${this.filters.id}&`
      }
      if (this.filters.search){
        fetch_url += `search_value=${this.filters.search}&`
      }
      if (this.filters.quick_date_filter) {
        fetch_url += `quick_date_filter=${this.filters.quick_date_filter}&`
      }
      if (this.filters.date_from){
        fetch_url += `date_from=${this.filters.date_from}&`
      }
      if (this.filters.date_to){
        fetch_url += `date_to=${this.filters.date_to}&`
      }
      this.request({
        url: this.endpoint(fetch_url),
        method: "get",
        loading:true,
        success: data => {
          this.orders = data.results
          this.order_total = data.count
          this.isLoading = false
        }
      })
    },
    printOrders() {
      let print_url = `https://api.exuni.ir/shop/adminShippedOrdersList/html?token=${this.token}&`
      print_url += `status=sh&`
      if (this.selected.length > 0){
        print_url += `id__in=${this.selected.join(',')}&`
      }
      if (this.filters.id){
        print_url += `id=${this.filters.id}&`
      }
      if (this.filters.search){
        print_url += `search_value=${this.filters.search}&`
      }
      if (this.filters.quick_date_filter) {
        print_url += `quick_date_filter=${this.filters.quick_date_filter}&`
      }
      if (this.filters.date_from){
        print_url += `date_from=${this.filters.date_from}&`
      }
      if (this.filters.date_to){
        print_url += `date_to=${this.filters.date_to}&`
      }
      window.open(print_url)
    },
    toggleSelectAll() {
      this.selected = this.selectAll ? this.filteredOrders.map(o => o.id) : [];
    },
    statusClass(status) {
      console.log(status)
      const map = {
        pe: "text-center  text-yellow-600 bg-yellow-100 px-2 py-1 rounded-full text-[6px]",
        pa: "text-center  text-green-600 bg-green-100  px-2 py-1 rounded-full text-[6px]",
        pr: "text-center  text-blue-600 bg-blue-100 px-2 py-1 rounded-full text-[6px]",
        pc: "text-center  text-indigo-800 bg-indigo-200 px-2 py-1 rounded-full text-[6px]",
        sh: "text-center  text-purple-600 bg-purple-100 px-2 py-1 rounded-full text-[6px]",
        de: "text-center  text-green-600 bg-green-100 px-2 py-1 rounded-full text-[6px]",
        ca: "text-center  text-red-600 bg-red-100 px-2 py-1 rounded-full text-[6px]",
        re: "text-center  text-gray-600 bg-gray-100 px-2 py-1 rounded-full text-[6px]",
      };
      return map[status] || "bg-gray-200 text-gray-700 px-2 py-1 rounded-full text-[6px]";
    },
    formatDate(date) {
      return date ? date.split("T")[0] : "-";
    },
    applyQuickDateFilter() {
      this.filters.date_from = '';
      this.filters.date_to = '';
      this.fetchOrders();
    },
    fetchTotal() {
      this.request({
        url: this.endpoint("shop/ordersSum"),
        method: "get",
        success: (res) => {
          this.total = res.shipped_total || 0;
        },
      });
    },

  },
  mounted() {
    this.fetchOrders();
    this.fetchTotal();
  }
};
</script>

<style scoped>
table th,
table td {
  text-align: right;
}
</style>

